import * as React from 'react';
import NumberFormat from 'react-number-format';
import { cn } from '@/lib/utils';

interface CurrencyInputProps {
  value?: string | number;
  onValueChange?: (value: string) => void;
  className?: string;
  invalid?: boolean;
  placeholder?: string;
  disabled?: boolean;
}

const CurrencyInput = React.forwardRef<HTMLInputElement, CurrencyInputProps>(
  (
    {
      className,
      value,
      onValueChange,
      invalid,
      placeholder,
      disabled,
      ...props
    },
    ref,
  ) => {
    const handleValueChange = (values: any) => {
      const { value: newValue } = values;
      onValueChange?.(newValue);
    };

    return (
      <NumberFormat
        getInputRef={ref}
        value={value}
        onValueChange={handleValueChange}
        thousandSeparator=","
        prefix="$"
        allowNegative={false}
        decimalScale={0}
        placeholder={placeholder}
        disabled={disabled}
        className={cn(
          'tw-file:text-foreground tw-placeholder:text-muted-foreground tw-selection:bg-primary tw-selection:text-primary-foreground tw-dark:bg-input/30 tw-border-input tw-flex tw-h-9 tw-w-full tw-min-w-0 tw-rounded-md tw-border tw-bg-background tw-px-3 tw-py-1 tw-text-sm tw-shadow-xs tw-transition-[color,box-shadow] tw-outline-none tw-file:inline-flex tw-file:h-7 tw-file:border-0 tw-file:bg-transparent tw-file:text-sm tw-file:font-medium tw-disabled:pointer-events-none tw-disabled:cursor-not-allowed',
          'tw-focus-visible:border-ring tw-focus-visible:ring-ring/50 tw-focus-visible:ring-[3px]',
          'tw-aria-invalid:ring-destructive/20 tw-dark:aria-invalid:ring-destructive/40 tw-aria-invalid:border-destructive',
          invalid && '!tw-border-red-500 focus-visible:!tw-ring-red-500',
          disabled && '!tw-bg-gray-50',
          className,
        )}
        {...props}
      />
    );
  },
);

CurrencyInput.displayName = 'CurrencyInput';

export { CurrencyInput };
